import { createFileRoute, redirect } from "@tanstack/react-router";
import { sessionQuery } from "@/api/queries/session";
import { isSafeReturnTo } from "@/domain/identity";
import { WelcomePage } from "@/pages/auth/WelcomePage";

export type WelcomeStep = "identity" | "interests";

export interface WelcomeSearch {
  step: WelcomeStep;
  returnTo?: string;
}

// Requires a session. Identity is for an Account without a Person; interests for one with a Person.
export const Route = createFileRoute("/_onboarding/welcome")({
  validateSearch: (search: Record<string, unknown>): WelcomeSearch => ({
    step: search.step === "interests" ? "interests" : "identity",
    returnTo: typeof search.returnTo === "string" && isSafeReturnTo(search.returnTo) ? search.returnTo : undefined,
  }),
  beforeLoad: async ({ context, search }) => {
    const session = await context.queryClient.ensureQueryData(sessionQuery());
    if (session.status === "anonymous") throw redirect({ to: "/join", search: { returnTo: search.returnTo } });
    if (search.step === "identity" && session.person) {
      throw redirect({ to: "/welcome", search: { step: "interests", returnTo: search.returnTo } });
    }
    if (search.step === "interests" && !session.person) {
      throw redirect({ to: "/welcome", search: { step: "identity", returnTo: search.returnTo } });
    }
  },
  component: WelcomePage,
});
